import { faroCoreApiClient } from "@api/faro-core-api-client";
import { createAsyncThunk } from "@reduxjs/toolkit";
/**
 * Fetches active members from the backend so they can be put into the store
 * @throws {HttpUtils.FetchError} if the Core API client request fails and not in dev mode
 */
export const fetchActiveMembers = createAsyncThunk("activeMembers/fetchActiveMembers", async ({
  companyId
}) => {
  return await faroCoreApiClient.company.getActiveMembers({
    companyId
  });
}, {
  condition: ({
    shouldForceFetch = false
  }, {
    getState
  }) => {
    const state = getState();

    // Skip fetching if active members have already been fetched, unless asked to fetch them again
    return shouldForceFetch || state.activeMembers.fetching.status !== "succeeded";
  }
});